{
  "title": "Chat",
  "search": {
    "next": "Next (Enter)",
    "prev": "Previous (Shift+Enter)",
    "close": "Close (ESC)"
  },
  "lightbox": {
    "view_full": "View full size",
    "close": "Close (Esc)",
    "close_aria": "Close",
    "download": "Download original",
    "download_aria": "Download image"
  },
  "effort": {
    "off_label": "Off",
    "off_title": "No reasoning effort",
    "default_label": "Default ({{level}})",
    "default_title": "Use the agent default (set in the settings)",
    "low_title": "Fast & cheap — simple tasks",
    "medium_title": "Balanced between speed and depth",
    "high_title": "Deep reasoning (default on Opus)",
    "xhigh_title": "Long-horizon — recommended for agentic coding",
    "max_title": "Maximum depth, no token limit"
  },
  "model_hint": "Switch model for this agent (applies to all sessions)",
  "model": "Model",
  "effort_label": "Depth",
  "tabs": {
    "direct": "Direct",
    "projects": "Projects"
  },
  "session": {
    "list_title": "Sessions",
    "new": "New session",
    "no_sessions": "No sessions yet",
    "no_buddy": "No Buddy sessions",
    "no_direct": "No direct chats",
    "no_project": "No project chats",
    "select_or_new": "Select a session on the right or start a new one.",
    "without_title": "Untitled",
    "id_short": "Session ID",
    "system_prompt_label": "System prompt:",
    "orphaned": "orphaned",
    "orphaned_banner": "This session is orphaned — its agent was deleted.",
    "new_chat": "New Chat",
    "context_large": "Context: ~{{tokens}} tokens. New chat saves ~{{savings}} tokens.",
    "delete_session": "Delete session",
    "delete_confirm": "Really delete this session?",
    "unknown_project": "(unknown project)",
    "title_placeholder": "e.g. Research on idea XY",
    "title_label": "Title (optional)"
  },
  "new_dialog": {
    "title": "New session",
    "mode": {
      "direct": "Direct chat",
      "direct_hint": "With a master or specialist agent",
      "project": "In project",
      "project_hint": "With a project agent inside its workspace"
    },
    "agent_label": "Agent",
    "no_agents": "No active agent available.",
    "project_label": "Project",
    "no_projects": "No active project available.",
    "start": "Start"
  },
  "input": {
    "placeholder": "Write a message…",
    "placeholder_disabled": "Select a session first…",
    "hint": "Enter to send · Shift+Enter for new line",
    "stop_title": "Stop — cancel response"
  },
  "upload": {
    "button_title": "Attach file",
    "file_too_large": "{{name}} is too large. Maximum {{maxMiB}} MiB per file.",
    "total_too_large": "The attachments are too large in total. Maximum {{maxMiB}} MiB per message.",
    "too_many": "A maximum of {{maxFiles}} files per message is allowed."
  },
  "messages": {
    "empty": "Write a message to start…",
    "iteration": "Iteration {{n}}…"
  },
  "tokens": {
    "last_turn": "last turn",
    "tooltip": "Input ↑ · Output ↓ · Cache-Read ⚡ · Cache-Write 💾",
    "limit_tooltip": "Compaction threshold at {{limit}} tokens",
    "compact_imminent": "Compact soon",
    "compact_imminent_tooltip": "Auto-compaction will trigger on the next turn — manually compact now if you want.",
    "turns_tooltip": "Messages: {{count}} / {{max}} — compaction also fires when this count is reached, not only at the token threshold."
  },
  "compact": {
    "button": "Compact",
    "tooltip": "Summarize conversation now",
    "skipped": "Skipped: {{reason}}",
    "result": "{{summarized}} messages compacted, {{kept}} kept",
    "result_with_tokens": "{{summarized}} messages compacted, {{kept}} kept · {{tokens}} tokens",
    "reasons": {
      "too_short": "too short",
      "nothing_to_compact": "nothing to compact",
      "empty_to_summarize": "nothing to summarize",
      "cancelled_by_hook": "cancelled by {{hook}}"
    }
  },
  "compaction_block": {
    "title": "Conversation summarized",
    "stats_with_tokens": "{{tokens}} tokens compacted · {{read}} read · {{modified}} modified files",
    "stats": "{{read}} read · {{modified}} modified files",
    "files_read": "Files read",
    "files_modified": "Files modified",
    "summary": "Summary"
  },
  "bubble": {
    "copy": "Copy",
    "raw": "Raw JSON",
    "persisted": "Sent",
    "pending": "Sending…",
    "edit": "Edit",
    "cancel": "Cancel",
    "resend": "Resend",
    "resend_hint": "Ctrl+Enter to send, Esc to cancel. History from this message onwards will be discarded.",
    "retry": "Regenerate",
    "retry_hint": "Discard this answer and let the agent answer again."
  },
  "bubble_footer": {
    "tokens": "{{in}} ↑ · {{out}} ↓",
    "cache": "cache {{read}}r / {{create}}c",
    "iterations": "{{n}} iterations",
    "stop_reason": "stop: {{reason}}",
    "cost_tooltip": "Estimated cost based on public provider prices per 1M tokens. Cache-read and cache-write are included."
  },
  "tool_result": {
    "collapsed": "Output ({{chars}} chars, {{lines}} lines) — show"
  },
  "voice": {
    "speak": "Read aloud",
    "stop": "Stop",
    "click_to_speak": "Click to speak",
    "click_to_stop": "Click to stop"
  },
  "model_switch": "Switch model",
  "project_picker_title": "Active project — sets the working directory",
  "skill_catalog": {
    "title": "Skill catalog",
    "insert_hint": "Click to insert skill as instruction",
    "loading": "Loading…",
    "empty": "No skills available"
  },
  "agent_monitor": {
    "ready": "Ready",
    "done": "Done!"
  },
  "panel": {
    "expand": "Expand",
    "collapse": "Collapse"
  },
  "max_iter": {
    "continue_send": "Continue, please carry on.",
    "continue_label": "Continue"
  },
  "tool_confirm": {
    "message": "Agent wants to execute the following tool:",
    "protected": "Protected access — confirmation required:",
    "approve": "Allow",
    "deny": "Deny"
  },
  "prompts": {
    "button_title": "Prompt archive",
    "search": "Search prompts …",
    "loading": "Loading …",
    "empty": "No prompts saved yet.",
    "use": "Insert into chat",
    "edit": "Edit",
    "delete": "Delete",
    "used_n": "used {{n}}×",
    "confirm_delete": "Really delete prompt \"{{title}}\"?",
    "new_title": "New prompt",
    "edit_title": "Edit prompt",
    "field_title": "Title (e.g. HydraHive mascot)",
    "field_prompt": "Prompt text (the subject)",
    "field_style_anchor": "Style anchor — stays constant across a series (e.g. flat vector, warm earth tones)",
    "field_model": "Model (optional, e.g. openai/gpt-5-image-mini)",
    "field_tags": "Tags, comma-separated",
    "field_notes": "Notes (optional)",
    "field_public": "Public — visible to others",
    "save": "Save",
    "cancel": "Cancel",
    "cat": {
      "all": "All",
      "image": "Image",
      "music": "Music",
      "system": "System",
      "video": "Video",
      "speech": "Speech",
      "other": "Other"
    }
  },
  "delegation": {
    "result_title_one": "Result from specialist",
    "result_title_other": "Results from {{count}} specialists",
    "running": "working for {{minutes}} min · round {{rounds}}",
    "cancel": "Cancel task",
    "waiting": "Result ready — will be evaluated after your next message",
    "deliver_now": "Evaluate now",
    "status": {
      "running": "running",
      "done": "done",
      "error": "error",
      "paused": "paused",
      "timeout": "no answer",
      "cancelled": "cancelled",
      "lost": "lost"
    }
  }
}
